// utils/userPinger.js
let pingerInterval = null;

export const startUserPinger = ({ id, updateItem }) => {
  const ping = async () => {
    try {
      const updateInput = {
        id,
        user_status: 1,
      };
      await updateItem(updateInput);
      console.log('[Heartbeat] Status updated at', new Date().toISOString());
    } catch (err) {
      console.error('[Heartbeat] Failed to update user status:', err);
    }
  };

  if (!pingerInterval) {
    ping(); // First immediate ping
    pingerInterval = setInterval(ping, 60000); // Then every 30 seconds
  }
};

export const stopUserPinger = () => {
  if (pingerInterval) {
    clearInterval(pingerInterval);
    pingerInterval = null;
    console.log('[Heartbeat] Stopped');
  }
};
